    import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import LodaingImage from "../../assets/images/appdownloadImg.png"
import googlePlay from "../../assets/images/googleIcon.svg"
import appStore from "../../assets/images/AppStoreIcon.svg"
import mobIocn from "../../assets/images/mobileIocn.svg"
import { Link } from "react-router-dom";
const DownloadMyhealthcareApp=()=>{

    const [show, setShow] = useState(false);
    const getForModalTime = localStorage.getItem('setForModalTime');
    const setCurrentTime  = new Date();
    const setCurrentTimestamp = setCurrentTime.getTime();
    const minutes = 60*6;
    const setForModalTime = (new Date(setCurrentTimestamp + minutes*60000)).getTime();



   
      
    useEffect(() => {
        // console.log("setCurrentTimestamp", setCurrentTimestamp);
        // console.log("getForModalTime", getForModalTime)
        if(getForModalTime != null &&  getForModalTime >= setCurrentTimestamp){
            setShow(false);
        }else{
            setTimeout(() => {
                setShow(true);
              }, 20000);
        }
    }, [setCurrentTimestamp, getForModalTime])



    const handleClose = () => {
        setShow(false);
        localStorage.setItem('setForModalTime', setForModalTime);
      
    };
    return(
        <>
         <Modal className="downloadApp" centered="true" size="md"  show={show} onHide={handleClose}>
        <Modal.Header closeButton>        
        </Modal.Header>
        <Modal.Body>
            <div className="row justify-content-center justify-content-sm-start">
                <div className=" col-11 col-sm-7   align-self-center">
                    <p>                Download <span> MyHealthcare App </span>& book doctor consults, lab tests, homecare services & more!</p>

                </div>
                <div className="col-4 col-sm-4 d-none d-sm-block">
                    <img src={LodaingImage} alt="loader" className="mob-img" />
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
 
                <Link className="btn btn-primary" target="_blank" to="https://play.google.com/store/apps/details?id=com.innocirc.vcpatient&hl=en_IN&gl=US" onClick={()=>handleClose()} >
                   <img src={googlePlay} className="icon" alt="MyHealthcare Google Play" />  Goolge Play
                </Link>
                <Link className="btn btn-primary" target="_blank" to="https://apps.apple.com/in/app/myhealthcare/id1506349869"  onClick={()=>handleClose()} >
                <img src={appStore} className="icon" alt="MyHealthcare App Store" />  App Store
                </Link>
                <Link className="btn btn-primary"  to="tel:01141198700" onClick={()=>handleClose()}>
                <img src={mobIocn} className="icon" alt="MyHealthcare Call" /> 011 41198700
                </Link>
     
        </Modal.Footer>
       
      </Modal>
        </>
    )
}
export default DownloadMyhealthcareApp;